<template>
    <div class="container full-width map-bar">
        <div class="overlay"></div>
        <router-link to="/trail-guide"><img src="@/assets/images/map_icon.svg" class="map_icon"></router-link>
        <h3 class="has-color-primary">Explore Lewis County By Map</h3>
    </div> 
</template>

<script>
export default{
    name: 'MapBar',
}
</script>

<style scoped lang="sass">

    .map_icon 
        width: 12rem
  
    .map-bar
        display: flex
        justify-content: center
        align-items: center
        position: relative
        padding: .5rem 0 !important
        background-image: url('~@/assets/images/map_pattern.jpg')
  
        .overlay
            background: rgba(225, 255, 0, .8)
            z-index: 1

        img, h4, h3
            position: relative
            z-index: 2

        h3 
            margin-left: 4rem
            margin-bottom: 0
    

    @media (max-width: 768px) 
        .map-bar
            flex-direction: column

            h3
                margin-left: 0

        

</style>